<p-table [value]="feedbacks" dataKey="id" [rows]="limit" [loading]="loading" [rowHover]="true"
  styleClass="p-datatable-gridlines" [paginator]="true"   [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]" [totalRecords]="total" [globalFilterFields]="[]"
  responsiveLayout="scroll" [lazy]="true">
  <ng-template pTemplate="header">
    <tr>
      <th> Time </th>
      <th> Status </th>
      <th> User </th>
      <th> Type </th>
      <th> Rating </th>
      <th> </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-feedback>
    <tr>
      <td>{{feedback.RegisterTime|timeDiff}}</td>
      <td>{{feedback.Status}}</td>
      <td>{{feedback.UserProfile?.Name}}</td>
      <td> {{feedback.ItemType}}</td>
      <td> {{feedback.Rating}}</td>
      <td>
        <div class="tw-flex tw-flex-wrap tw-gap-2 tw-justify-center">
          <p-button icon="pi pi-check" severity="success" [text]="true" [rounded]="true"
            [disabled]="feedback.Status=='Approved'" (click)="setStatus(feedback, 'Approved')" />
          <p-button icon="pi pi-eye" severity="primary" [text]="true" [rounded]="true"
            (click)="showFeedback(feedback)" />
          <p-button icon="pi pi-times" severity="danger" [text]="true" [rounded]="true"
            [disabled]="feedback.Status=='Rejected'" (click)="setStatus(feedback, 'Rejected')" />
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="showFeedbackForm" appendTo="body" [modal]="true" [maximizable]="true">
  @if(selectedFeedback) {
  @if(selectedFeedback.ItemType == 'Order' && order) {
  <brt-submit-order-feedback [feedback]="selectedFeedback" [order]="order" [manage]="true"
    (updated)="showFeedbackForm=false" />
  }
  }
</p-dialog>